<header>
  <div class="logo">
    <img src="assets/images/logo.png" alt="npi" />
  </div>

  <nav>
    <ul>
      <li *ngFor="let item of navItems" [routerLink]="item.path" routerLinkActive="active">{{ item.name }}</li>
    </ul>
  </nav>

  <div dropdown class="user">
    <div class="avatar"><mat-icon>person</mat-icon></div>
    <div class="wrapper">
      <div dropdownToggle id="dropdown-trigger" class="trigger dropdown-toggle" type="button" aria-controls="dropdown">
        {{ user.first_name }}
        <span class="caret"></span>
      </div>
      <ul id="dropdown" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="dropdown-trigger">
        <li (click)="logout()" role="menuitem"><a class="dropdown-item">Uitloggen</a></li>
      </ul>
    </div>
  </div>
</header>
<main>
  <router-outlet></router-outlet>
</main>
